import React from "react";
import {
  useCompleteAppointmentMutation,
  useConfirmAppointmentMutation,
} from "../../../Services/inventory/Inventory";
import useThemeColors from "../../vehicle/ThemeColors";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ConfirmationModal = ({ storedWorkshopData, closeModal }) => {
  const navigate = useNavigate();

  const [confirmTrigger, { status }] = useCompleteAppointmentMutation();

  const confirmServiceRequest = async () => {
    try {
      const response = await confirmTrigger({
        id: storedWorkshopData?.appointment_id,
      });

      if (response?.data) {
        toast.success("Service completed successfully");
         sessionStorage.clear();

        closeModal();
        navigate("/vehicle/appointment");
      }
    } catch (error) {
      toast.error("Unable to complete this service");
    }
  };

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();
  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <label
          style={{
            fontSize: "18px",
            fontWeight: "600",
            fontFamily: "Karbon-semi",
          }}
        >
          Are you sure you want to complete this service?
        </label>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <button
          onClick={confirmServiceRequest}
          type="submit"
          style={{
            width: "100%",
            padding: "10px 25px",
            borderRadius: "20px",
            // background: `${selectedButtonBackgoundColors}`,
            // color: `${selectedButtonColors}`,
            // border: `1px solid ${selectedBorderColor}`,
            whiteSpace: "nowrap",
            background: `${selectedButtonBackgoundColors}`,
            color: `${selectedButtonColors}`,
            border: "none",
            // padding: "10px 20px",
            // borderRadius: "20px",
            fontSize: "15px",
            fontFamily: "Karbon-medium",
          }}
        >
          Complete Service
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
